<template>
  <div class="direct_message_history_dialog">
    <el-dialog custom-class="with-title" :title="title" :visible.sync="visible">
      <div class="dialog-content">
        <applicant-name :applicant="result.applicant"></applicant-name>
        <div class="messages">
          <div class="messages_wrapper">
            <div class="messages_list" v-if="result.messages.length">
              <div class="messages_item" v-for="message in result.messages" :key="message.id">
                <div class="messages_info">
                  <span class="messages_status is-sent" v-if="message.status === 'sent'"
                    ><span v-if="message.sendType === 'DM'">DM配信成功</span
                    ><span v-if="message.sendType === 'mention'">メンション配信成功</span></span
                  ><span class="messages_status is-failed" v-else-if="message.status === 'failed'"
                    ><span v-if="message.sendType === 'DM'">DM配信失敗</span
                    ><span v-if="message.sendType === 'mention'">メンション配信失敗</span></span
                  >{{ formatDatetime(message.actionDatetime) }}
                </div>
                <div class="messages_body" v-html="tweetText(message.body)"></div>
              </div>
            </div>
            <div class="messages_error" v-else>メッセージ履歴がありません。</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.messages {
  max-height: $spacing-unit * 75;
  margin: $spacing-unit * 2 (-$spacing-unit) * 2 (-$spacing-unit) * 2;
  overflow-y: auto;
  border-top: 1px solid $border-color;

  &_list {
    padding: $spacing-unit * 2;
  }

  &_item {
    margin: ($spacing-unit * 4) 0 0;

    &:first-child {
      margin: 0;
    }
  }

  &_info {
    font-size: $font-small-size;
    line-height: 1;
    color: $sub-text-color;
  }

  &_status {
    display: inline-block;
    padding: 2px ($spacing-unit * 2);
    margin: 0 $spacing-unit 0 0;
    color: white;
    border-radius: $spacing-unit * 2;

    &.is-sent {
      background: $success-color;
    }

    &.is-failed {
      background: $danger-color;
    }
  }

  &_body {
    margin: $spacing-unit 0 0;
    line-height: $line-height;
    white-space: pre-wrap;
  }

  &_error {
    padding: $spacing-unit * 2;
    line-height: $line-height;
  }
}
</style>
<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import ApplicantName from '@/client/components/_atoms/applicant_name'
import api from '@/client/core/api'
import { formatDatetime, formatTweetText } from '@/client/filters/filters'

export default defineComponent({
  components: {
    ApplicantName
  },
  data() {
    return {
      title: '',
      loading: false,
      error: false,
      visible: false,
      result: {
        applicant: {},
        messages: []
      }
    }
  },
  methods: {
    formatDatetime,

    /**
     * ポスト内容をHTMLに変換
     * @param {string} text ポストテキスト
     */
    tweetText(text: string): string {
      return formatTweetText(text)
    },

    /**
     * ダイアログを表示
     * @param {number} applicantId 応募者ID
     */
    open(applicantId: number) {
      this.visible = true

      const params = {
        applicantId
      }

      this.getMessageHistory(params).catch(() => {
        this.alert()
      })
    },

    /**
     * ダイアログを非表示
     */
    close() {
      this.visible = false
    },

    /**
     * エラー時の処理
     */
    alert() {
      this.$notify({
        title: 'メッセージ履歴がありません。',
        customClass: 'danger',
        duration: 5000
      })

      this.close()
    },

    /**
     * DM配信履歴を取得する
     * @param {Object<any>} params query params
     */
    async getMessageHistory(params: any) {
      const response = await api.get('/twitter_messages', { params })

      if (!response.data) {
        this.alert()
        return
      }

      this.result = response.data
      this.title = `メッセージ配信履歴(${response.data.messages.length}件)`
    }
  }
})
</script>
